import { Link } from 'react-router-dom'

export default function GenreBadge({ genre }) {
  const code = genre?.code ?? genre
  const name = genre?.name ?? genre

  return (
    <Link
      to={`/catalog?genre=${code}`}
      className="inline-block rounded-full font-medium transition-colors bg-accent-dim text-accent border border-transparent hover:border-accent px-2.5 py-0.5 text-[12px]"
    >
      {name}
    </Link>
  )
}
